// @flow
import React from 'react';

type Props = {
  value: string,
  error?: any,
  name: string,
  label: string,
  onChange: (event: SyntheticEvent<HTMLInputElement>) => void,
  type: 'text' | 'email' | 'password',
  className?: string
}

const AuthInput = (props: Props) => {
  const filled = props.value.length > 0 ? 'filled' : '';
  const error = props.error ? 'has-error' : '';
  return (
    <div className='auth-input'>
      <label
        htmlFor={props.name}
        className={`auth-input__label ${filled} ${error}`}
      >
        <span className='auth-input__floating-label'>{props.label}</span>
        <input
          name={props.name}
          type={props.type}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.label}
          {...props}
          className={`auth-input__input ${(props.className || '')}`}
        />
      </label>
      {props.error}
    </div>
  );
};

export default AuthInput;


// WEBPACK FOOTER //
// ./src/components/shared/AuthInput.js